const initState = () => {
  return [];
}

const events = (state=initState(), action) => {
  switch (action.type) {

    case "INIT_EVENTS":
      return action.payload;

    default:
      return state;
  }
}

export default events;
